<ngx-extended-pdf-viewer
	#pdfViewer
	[src]="url()"
	[base64Src]="base64Src()"
	[height]="height()"
	[class.redaction-mode]="redactionMode()"
	(pageRendered)="onPageRendered($event)"
></ngx-extended-pdf-viewer>
